module.exports = __webpack_public_path__ + "static/media/p-intro-2.bac9eec8.png";